export default {
    data() {
        return {
            products_filter: "",
            sorting: [
                {
                    value: "price_low_to_high",
                    label: "Price Low to High"
                },
                {
                    value: "price_high_to_low",
                    label: "Price High to Low"
                },
                {
                    value: "name_a_to_z",
                    label: "Name A to Z"
                },
                {
                    value: "name_z_to_a",
                    label: "Name Z to A"
                }
            ],
            params: {
                order: '',
                sort: ''
            }
        }
    },
    methods: {
        applyFilters(filter) {
            switch (filter) {
                case "price_low_to_high":
                    this.params.order = "price";
                    this.params.sort = "asc";
                    break;
                case "price_high_to_low":
                    this.params.order = "price";
                    this.params.sort = "desc";
                    break;
                case "name_a_to_z":
                    this.params.order = "name";
                    this.params.sort = "asc";
                    break;
                case "name_z_to_a":
                    this.params.order = "name";
                    this.params.sort = "desc";
                    break;
            }
            this.$emit('filters:apply', this.params)
        },
    }
}
